<template>
  <div class="chinese-catering">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <img
        src="../assets/images/cnybanner.png"
        alt=""
        width="100%"
        height="100%"
      />
      <div class="center">
        <h1>{{ $t("message.chinese.banner.h") }}</h1>
        <h2>{{ $t("message.chinese.banner.p") }}</h2>
        <menubtn></menubtn>
      </div>
    </div>
    <!-- 内容 -->
    <div class="party-c">
      <!-- <div class="chi_menu">
        <div class="chi-f">
          <div>
            <img
              v-if="this.$i18n.locale === 'zh'"
              src="../assets/images/caterersmenu2.png"
              alt=""
              @click="yiqing = true"
            />
            <img
              v-else
              src="../assets/images/caterersmenu2EN.png"
              alt=""
              @click="yiqing = true"
            />
          </div>
          <div>
            <h3>{{ $t("message.caterersmenu.h1") }}</h3>
            <h3>{{ $t("message.caterersmenu.h2") }}</h3>
            <a href="https://wa.link/oq75wi" target="_black">
              <el-button>{{ $t("message.caterersmenu.btn1") }}</el-button>
            </a>
          </div>
        </div>
        <div class="chi-f">
          <div>
            <img
              v-if="this.$i18n.locale === 'zh'"
              src="../assets/images/caterersmenu1.png"
              alt=""
              @click="yiqing2 = true"
            />
            <img
              v-else
              src="../assets/images/caterersmenu1EN.png"
              alt=""
              @click="yiqing2 = true"
            />
          </div>
          <div>
            <h3>{{ $t("message.caterersmenu.h3") }}</h3>
            <h3>{{ $t("message.caterersmenu.h4") }}</h3>
            <a href="https://wa.link/smc86f" target="_black">
              <el-button>{{ $t("message.caterersmenu.btn1") }}</el-button>
            </a>
          </div>
        </div>
      </div> -->
      <!-- SEO -->
      <div class="chi-center">
        <div class="chi-xuan">
          <h2>{{ $t("message.chinese.content.div1.h1") }}</h2>
          <div class="cny-flex">
            <div class="cny-f-bg1"></div>
            <div v-if="lau">
              <p class="cny-p">
                {{ $t("message.chinese.content.div1.p1") }}
              </p>
              <p class="cny-p">
                {{ $t("message.chinese.content.div1.p2") }}
              </p>
            </div>
            <div v-else>
              {{ $t("message.chinese.content.div1.p3") }}
            </div>
          </div>
        </div>
        <div class="chi-xuan">
          <h2>{{ $t("message.chinese.content.div2.h1") }}</h2>
          <div class="cny-flex">
            <div class="cny-f-bg2"></div>
            <div>
              <p class="cny-p">{{ $t("message.chinese.content.div2.p1") }}</p>
            </div>
          </div>
        </div>
        <div class="activity-contanier">
          <div class="activity-main">
            <Title :title="$t('message.chinese.context.h2TitleOne')"></Title>
            <Content :content="$t('message.chinese.context.pContentOneFirst')"></Content>
            <Content :content="$t('message.chinese.context.pContentOneSecond')"></Content>
          </div>
        </div>
        <div class="chi-tui">
          <h2>{{ $t("message.chinese.content.div3.h2") }}</h2>
          <a href="https://wa.link/oq75wi" target="_black">
            <el-button type="primary">{{$t("message.chinese.content.div3.btn") }}</el-button></a>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <el-dialog class="aaa" :visible.sync="yiqing" width="80%">
      <img
        v-if="this.$i18n.locale === 'zh'"
        src="../assets/images/caterersmenu2.png"
        alt
        width="100%"
        height="100%"
      />
      <img
        v-else
        src="../assets/images/caterersmenu2EN.png"
        alt
        width="100%"
        height="100%"
      />
    </el-dialog>
    <el-dialog class="aaa" :visible.sync="yiqing2" width="80%">
      <img
        v-if="this.$i18n.locale === 'zh'"
        src="../assets/images/caterersmenu1.png"
        alt
        width="100%"
        height="100%"
      />
      <img
        v-else
        src="../assets/images/caterersmenu1EN.png"
        alt
        width="100%"
        height="100%"
      />
    </el-dialog>
  </div>
</template>

<script>
import header from "../components/header";
import menubtn from "../components/menubtn";
import Title from './common/title.vue'
import Content from './common/content.vue'
export default {
  name: "caterers",
  data() {
    return {
      imgs: require("../assets/images/caterersmenu2.png"),
      imgs2: require("../assets/images/caterersmenu1.png"),
      menuimg1: require("../assets/images/caterersmenu2.png"),
      menuimg2: require("../assets/images/caterersmenu1.png"),
      yiqing: false,
      yiqing2: false,
      lau: true
    };
  },
  mounted() {
    if (this.$i18n.locale === "zh") {
      this.lau = true;
    } else {
      this.lau = false;
    }
  },
  components: {
    "v-header": header,
    menubtn,
    Title,
    Content
  },
  updated() {
    if (this.$i18n.locale === "zh") {
      this.lau = true;
    } else {
      this.lau = false;
    }
  }
};
</script>
<style lang="less" scoped>
.activity-contanier {
  background-image: url("../assets/images/bodybg.jpg");
  background-size: 100% 100%;

  .activity-main {
    width: 80%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.party-c{
  margin-top: 50px;
}
.chinese-catering .chi-center {
  width: 75%;
  margin: 0 auto ;
}
.chinese-catering .chi-center > div:nth-child(1) {
  margin-bottom: 5%;
}
.chinese-catering .chi-center .chi-xuan > h2 {
  margin-bottom: 20px;
  border-left: 3px solid;
  padding: 0 2%;
}
.chinese-catering .chi-center .chi-xuan .cny-flex {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  height: 30vh;
  overflow: hidden;
}
.chinese-catering .cny-f-bg1 {
  background-image: url("../assets/images/cnybg1.jpg");
  background-size: 100% 100%;
}
.chinese-catering .cny-f-bg2 {
  background-image: url("../assets/images/cnybg2.jpg");
  background-size: 100% 100%;
}
.chi-center .chi-xuan .cny-flex > div:nth-child(1) {
  flex: 0 0 40%;
  height: 100%;
  display: flex;
  align-items: center;
}
.chi-center .chi-xuan .cny-flex p {
  flex: 0 0 100%;
}
.chi-center .chi-xuan .cny-flex > div:nth-child(2) {
  flex: 0 0 60%;
  height: 100%;
  padding: 0 5%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.chi-center .chi-xuan .cny-p {
  font-size: 15px;
  line-height: 25px;
}
.chinese-catering .chi_menu {
  width: 40%;
  margin: 5% auto;
}
.chinese-catering .chi_menu > div:nth-child(1) {
  margin-bottom: 5%;
}
.chinese-catering .chi-f {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.chinese-catering .chi-f > div {
  text-align: center;
}
.chinese-catering .chi-f > div:nth-child(1) {
  flex: 0 0 60%;
}
.chinese-catering .chi-f > div:nth-child(2) {
  flex: 0 0 40%;
}
.chinese-catering .chi-f > div img {
  width: 50%;
  height: 50%;
}
.chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
  margin-bottom: 2%;
  font-size: 1.5vw;
  margin-bottom: 6%;
}
.chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
  margin-bottom: 2%;
  font-size: 1vw;
}
.chinese-catering .chi-f > div button {
  margin-top: 5%;
  background: #eb6410;
  border: 1px solid #eb6410;
  color: #fff;
}
.chinese-catering .chi-tui {
  text-align: center;
  padding: 5% 0;
}
.chinese-catering .chi-tui > h2 {
  margin-bottom: 3%;
}
.chinese-catering .chi-tui .el-button--primary:hover {
  background: #eb6410;
  border-color: #eb6410;
  color: #fff;
}
/* 广告 */
.chinese-catering .banner {
  /* position: relative;
  width: 100%;
  background-size: 100% 100%;
  margin: 100px 0 0 0; */
  position: relative;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  background-size: 100% 100%;
  margin: 110px 0 0% 0;
}
.chinese-catering .banner h1,
.chinese-catering .banner h2 {
  text-align: center;
  color: white;
}
.chinese-catering .banner h1 {
  font-weight: bold;
  font-size: 4.7vw;
}
.chinese-catering .banner h2 {
  margin: 1% 0;
  font-size: 1.7vw;
  letter-spacing: 5px;
}
.chinese-catering .banner .center {
  width: 100%;
  padding: 0 20%;
  box-sizing: border-box;
  position: absolute;
  text-align: center;
  color: white;
  flex: 0 0 100%;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 10px;
}
.chinese-catering .banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
@media (max-width: 1500px) {
  .chinese-catering .chi_menu {
    width: 50%;
  }
  .chinese-catering .chi-center {
    width: 90%;
  }
  .chinese-catering .banner h1 {
    font-weight: bold;
    font-size: 5vw;
  }
  .chinese-catering .banner h2 {
    margin: 1% 0;
    font-size: 2vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 1.9vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 1.2vw;
  }
}
@media (max-width: 1275px) {
  .chinese-catering .chi_menu {
    width: 70%;
  }
}
@media (max-width: 1360px) {
  .chinese-catering .banner .center {
    padding: 0 10%;
  }
  .chinese-catering .banner h2 {
    letter-spacing: 4px;
  }
}
@media (max-width: 1100px) {
  .chinese-catering .banner h1 {
    font-weight: bold;
    font-size: 5.5vw;
  }
  .chinese-catering .banner h2 {
    margin: 1% 0;
    font-size: 2vw;
  }
  .chinese-catering .chi-center {
    width: 95%;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(1) {
    flex: 0 0 50%;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(2) {
    flex: 0 0 50%;
    padding: 0 2%;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 2.3vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 1.5vw;
  }
}
@media (max-width: 950px) {
  .chinese-catering .banner h1 {
    font-size: 6vw;
  }
  .chinese-catering .banner h2 {
    font-size: 2.6vw;
  }
}
@media (max-width: 890px) {
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 2.5vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 1.9vw;
  }
  .chinese-catering .chi-f > div img {
    width: 60%;
  }
}
@media (max-width: 820px) {
  .chinese-catering .banner .center {
    padding: 0 5%;
  }
  .chinese-catering .banner .el-button.el-button--success {
    width: 60%;
  }
  .chinese-catering .chi_menu {
    width: 90%;
  }
  .chinese-catering .chi-f > div {
    flex: 0 0 100%;
  }
  .chinese-catering .chi-f > div:nth-child(2) {
    padding: 5% 0;
  }
  .chinese-catering .banner h1 {
    font-weight: bold;
    font-size: 7vw;
  }
  .chinese-catering .banner h2 {
    margin: 1% 0;
    font-size: 3vw;
    letter-spacing: 2px;
    margin-top: 10px;
  }
  .chinese-catering .chi-center {
    width: 90%;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(1) {
    flex: 0 0 100%;
    height: 40vh;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(2) {
    flex: 0 0 100%;
    padding: 1% 0;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(2) p:nth-child(1) {
    margin-bottom: 20px;
  }
  .chinese-catering .chi-center .chi-xuan .cny-flex {
    height: auto;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 2.7vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 2vw;
  }
}
</style>
<style>
.chinese-catering .banner .el-button.el-button--success {
  display: block;
  width: 100%;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.chinese-catering .banner .el-dialog {
  margin-top: 12vh !important;
}
.chinese-catering .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}
.chinese-catering .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
/* @media (max-width: 820px) {
  .chinese-catering .banner .el-button.el-button--success {
    width: 60%;
  }
} */
@media (max-width: 780px) {
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 2.5vw;
    margin-bottom: 10px;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 1vw;
  }
  .chinese-catering .chi-f > div:nth-child(1) {
    flex: 0 0 100%;
  }
  .chinese-catering .chi-f > div:nth-child(2) {
    flex: 0 0 100%;
  }
  .chinese-catering .chi-f > div button {
    margin-top: 0px;
  }
}
@media (max-width: 700px) {
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 3vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 2.3vw;
  }
}
@media (max-width: 565px) {
  .chinese-catering .banner {
    margin: 135px 0 0 0;
  }
}
@media (max-width: 480px) {
  .chinese-catering .banner h1 {
    font-weight: bold;
    font-size: 9vw;
    letter-spacing: 3px;
  }
  .chinese-catering .banner h2 {
    margin: 1% 0;
    font-size: 4.2vw;
    letter-spacing: 1px;
  }
  .chi-center .chi-xuan > h2 {
    font-size: 20px;
  }
  .chinese-catering .banner {
    height: 200px;
  }
  .chinese-catering .banner {
    margin: 135px 0 0 0;
  }
  .chinese-catering .banner .center {
    height: 70%;
  }
  .chi-center .chi-xuan .cny-flex > div:nth-child(1) {
    height: 30vh;
  }
  .chinese-catering .banner .center {
    padding: 0 10px;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(1) {
    font-size: 4.7vw;
  }
  .chinese-catering .chi-f > div:nth-child(2) > h3:nth-child(2) {
    font-size: 3.7vw;
  }
}
</style>
